import { Box, Chip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ConfirmPopover } from "../../component";

export const columns = (handleView, handleDelete) => [
  {
    accessorKey: "sortOrder",
    header: "S. No.",
    style: {
      width: 70,
    },
  },
  {
    accessorKey: "heading1",
    header: "Heading 1",
  },
  {
    accessorKey: "heading2",
    header: "Heading 2",
  },
  {
    accessorKey: "video",
    header: "Video URL",
    style: {
      width: 260,
    },
    cell: (ele) => ele || "N/A",
  },
  {
    accessorKey: "isActive",
    header: "Status",
    cell: (ele) => {
      return ele === true ? (
        <Chip label="Enabled" variant="outlined" color="success" size="small" />
      ) : (
        <Chip label="Disabled" variant="outlined" color="error" size="small" />
      );
    },
  },
  {
    accessorKey: "action",
    header: "Action",
    style: {
      width: 150,
    },
    cell: (ele, row) => {
      return (
        <Box>
          <IconButton
            sx={{ mr: 0.5 }}
            aria-label="edit"
            color="secondary"
            onClick={() => handleView(row, "/app/add-menu-article")}
          >
            <EditIcon />
          </IconButton>
          <ConfirmPopover
            title="Sure to delete?"
            onConfirm={() => handleDelete(row._id)}
          >
            <IconButton aria-label="delete" color="error">
              <DeleteOutlineIcon />
            </IconButton>
          </ConfirmPopover>
        </Box>
      );
    },
  },
];
